(function () {
	function initializeBlock(benefit) {
		EmblaCarousel( benefit );
	}

	const benefits = document.querySelectorAll( ".block-im-benefits" );

	for (const benefit of benefits) {
		initializeBlock( benefit );

		const wrap       = document.querySelector( ".embla-benefit" );
		const viewPort   = wrap.querySelector( ".embla-viewport" );
		const buttonPrev = wrap.querySelector( ".embla-button.-prev" );
		const buttonNext = wrap.querySelector( ".embla-button.-next" );
		const embla      = EmblaCarousel(
			viewPort,
			{
				align: 'start',
				containScroll: "trimSnaps"
			}
		);

		buttonPrev.addEventListener( 'click', embla.scrollPrev, false );
		buttonNext.addEventListener( 'click', embla.scrollNext, false );
	}
})();
